/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon64Regular = forwardRef('NetDownloadIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 5a1.5 1.5 0 0 1 1.5 1.5v37.716a4.49 4.49 0 0 0 1.49-.88l14.014-12.457a1.5 1.5 0 1 1 1.992 2.242L36.983 45.578a7.5 7.5 0 0 1-9.966 0L13.004 33.12a1.5 1.5 0 1 1 1.992-2.242L29.01 43.336a4.49 4.49 0 0 0 1.49.88V6.5A1.5 1.5 0 0 1 32 5Z" }),
        React.createElement("path", { d: "M7 56.5A1.5 1.5 0 0 1 8.5 55h47a1.5 1.5 0 0 1 0 3h-47A1.5 1.5 0 0 1 7 56.5Z" })));
});
